import { Component } from '@angular/core';

@Component({
  selector: 'gw-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./../../../scss/components/_top-bar.scss']
})
export class TopBarComponent {}
